import EllipsisMenu from "../../../../components/EllipsisMenu/EllipsisMenu"
import { ScanMedia } from "../../../../types/types"
import { getDate } from "../../../../utils/utils"
import AnalysisSection from "../AnalysisSection/AnalysisSection"
import { ScanMediaSectionProps } from "./ScanMediaSection.types"
import "./ScanMediaSection.css"
import SkeletonLoadingView from "../../../../components/SkeletonLoadingView/SkeletonLoadingView"

const ScanMediaSection = (props: ScanMediaSectionProps) => {
  const { 
    media,
    ellipsisMenu
  } = props

  if (media === undefined) {
    return (
      <AnalysisSection title="Scan Images">
        <div className="analysis-section">
          <div className="scan-media-container">
            {[...Array(3)].map((_, key) => (
              <div key={key}>
                <SkeletonLoadingView style={{height: "9rem", width: "15rem"}} />
              </div>
            ))}
          </div>
        </div>
      </AnalysisSection>
    )
  }

  return (
    <AnalysisSection title="Scan Images" titleChild={
      <EllipsisMenu ellipsisMenu={ellipsisMenu} />
      }
    >
      <div className="analysis-section">
        <div className="scan-media-container">
          {media.map((m: ScanMedia, key) => (
            <div key={m.id}>
              <img 
                className="scan-media-image" 
                src={`data:image/png;base64,${m.base64_string}`} 
                alt={`Scan media ${key} `}
              />
              <p className="date-text">{getDate(media[key].date)}</p>
            </div>
          ))}
        </div>
        {media.length === 0 && (
          <div className="no-scan-images-container">
            <p className="no-content-label">No scan images available for this section.</p>
          </div>
        )}
      </div>
    </AnalysisSection>
  )
}

export default ScanMediaSection